import { Text } from "@react-pdf/renderer";
import { useMemo } from "react";

const PdfPageTitle = ({ children, fontSize = 16, bold = true, style }) => {
  const styles = useMemo(() => {
    return {
      // fontSize: 9,
      // fontWeight: bold ? "bold" : "normal",
      // color: "#666666",
      //
      fontSize: fontSize,
      marginBottom: 15,
      fontWeight: "bold",
      color: "#333333",
      ...style,
    };
  }, [style, fontSize]);

  return <Text style={styles}>{children}</Text>;
};

export default PdfPageTitle;
